import { AnimatePresence, motion } from 'framer-motion';
import RetryIconCircle from '../../assets/icons/RetryIconCircle';
import { RetryButton, RetryIconContainer } from '../../pages/connecting/styles';
import { QRCode } from './QRCode';
import {
  LogoContainer,
  LogoIcon,
  QRCodeContainer,
  QRCodeContent,
  QRPlaceholder,
  StyleRetryButtonWrapper,
} from './styles';
import type { CustomQRCodeProps } from './types';

function CustomQRCode({
  value,
  image,
  imageBackground,
  ecl = 'M',
  imagePosition = 'center',
  failed,
  failedCallback,
}: CustomQRCodeProps) {
  const Logo = image;

  return (
    <QRCodeContainer>
      {failed && (
        <StyleRetryButtonWrapper>
          <RetryButton
            aria-label='Retry'
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            whileTap={{ scale: 0.9 }}
            transition={{ duration: 0.1 }}
            onClick={failedCallback}
          >
            <RetryIconContainer>
              <RetryIconCircle />
            </RetryIconContainer>
          </RetryButton>
        </StyleRetryButtonWrapper>
      )}

      <QRCodeContent>
        {image && (
          <LogoContainer>
            <LogoIcon
              $wcLogo={imagePosition !== 'center'}
              style={{
                background: imagePosition === 'center' ? imageBackground : undefined,
              }}
            >
              {Logo}
            </LogoIcon>
          </LogoContainer>
        )}

        <AnimatePresence initial={false}>
          {value ? (
            <motion.div
              key={value}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0, position: 'absolute', inset: [0, 0] }}
              transition={{
                duration: 0.2,
              }}
            >
              <QRCode uri={value} size={288} ecl={ecl} clearArea={!!(imagePosition === 'center' && image)} />
            </motion.div>
          ) : (
            <QRPlaceholder
              initial={{ opacity: 0.2 }}
              animate={{ opacity: 0.2 }}
              exit={{ opacity: 0, position: 'absolute', inset: [0, 0] }}
              transition={{
                duration: 0.2,
              }}
              $failed={failed}
            >
              <span />
              <span />
              <span />
              <div />
            </QRPlaceholder>
          )}
        </AnimatePresence>
      </QRCodeContent>
    </QRCodeContainer>
  );
}
CustomQRCode.displayName = 'CustomQRCode';

export default CustomQRCode;
